import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwRadioField";

/**
 * VuwFlgField (extends VuwRadioField)
 * @options
 * - {Boolean} required
 * - {Array | Object} dataOption
 */
vuwer.appendKlass("VuwFlgField", {
	inpType: "flg",
	
	getInpElm: function(value) {
		if( u_.isNumber(value) ) {
			value = !!value ? 0 : 1;
		}
		
		return Klass("VuwFlgField").parent.getInpElm.call(this, value);
	},
	
	renderField: function() {
		if( !Array.isArray(this.dataOption) ) {
			csl.warn.red(this.getAddress() + ".renderField() ... flg's dataOption is must be array.");
			return this;
		} else
		if(this.dataOption.length !== 2) {
			csl.warn.red(this.getAddress() + ".renderField() ... flg's dataOption has only 2 items.");
			return this;
		}
		
		return Klass("VuwFlgField").parent.renderField.call(this);
	},
	
	_renderField: function() {
		var
			clsList = this.inpClassList.join(" "),
			opt = {
				"_1": this.dataOption[1],
				"_0": this.dataOption[0]
			},
			$field = $("<div/>").addClass("vuw-field field-" + this.inpType).attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			});
		
		return $field.append.apply( $field, Object.keys(opt).map(function(k, i) {
			var
				val = k.replace(/^_/, ""),
				inpId = ["inp", this.idStr, val].join("_");
			
			return $("<fieldset/>").append(
				$("<input/>").addClass(clsList).attr({
					type: "radio",
					name: this.paramKey,
					id: inpId
				}).val(val),
				$("<label/>").attr("for", inpId).addClass("hover-target").html( $.parseHTML(opt[k]) )
			);
		}, this) );
	}
}, "VuwRadioField");
